<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card no-header>
          <b-form>
            <app-cajas
              label="Caja"
              :nombre="cajaNombre"
              :lista="cajasList"
              :labelCols="1"
              @updated="cajaActualizada">
            </app-cajas>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="abrirCaja">Abrir</b-button>
            <b-button size="sm" variant="danger" class="footer-button"
              @click.prevent="goBack">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal title="SGC" 
        v-model="modalMsj" 
        header-bg-variant="light"
        ok-only 
        ok-variant="primary footer-button"
        @ok='okAction' @hidden="hiddenAction">
      {{ modalMensaje }}
    </b-modal>
  </div>
</template>

<script>
import Cajas from '../shared/abmSelect.vue';

export default {
  name: 'ABM',
  components: {
    appCajas: Cajas,
  },
  data () {
    return {
      modalMensaje: '',
      modalMsj: false,
      modalOkAction: null,
      modalHiddenAction: null,

      cajaNombre: null,
      cajas: [],
      cajasList: []
    }
  },
  created() {
    // this.showSpinner();
    this.$store.dispatch('cajas/getCajasAbrirSelect')
      .then(() => {
        this.cajas = this.$store.getters['cajas/cajasSelect'];
        this.cajasList = this.$store.getters['cajas/cajasSelectList'];
      })
      .finally(() => {
        // this.hideSpinner();
      })
  },  
  methods: {
    okAction(){
      if (this.modalOkAction) {
        this.modalOkAction();
      }
    },
    hiddenAction(){
      if (this.modalHiddenAction) {
        this.modalHiddenAction();
      }
    },
    abrirCaja () {
      let caja;
      if (this.cajaNombre) {
        caja = this.getSelected(this.cajas, this.cajaNombre);
      }
      
      let errorCaja = Boolean(true);
      if (caja) {
        if (caja.id) {
          if (caja.id != 0) {
            errorCaja = Boolean(false);
          }
        }
      }

      if (errorCaja) {
        this.modalOkAction = null;
        this.modalHiddenAction = null;
        this.modalMensaje = "Seleccione la caja correspondiente.";
        this.modalMsj = true;
      } else {
        this.showSpinner();
        this.$store.dispatch('cajaregistro/abrirCaja', caja.id)
          .then(() => {
            this.modalOkAction = this.goList;
            this.modalHiddenAction = this.goList;
            this.modalMensaje = "La caja seleccionada se abrió con éxito";
            this.modalMsj = true;
          })
          .catch( error => {
            this.modalOkAction = null;
            this.modalHiddenAction = null;
            this.modalMensaje = error;
            this.modalMsj = true;
          })
          .finally(() => {
            this.hideSpinner();
          })
      }
    },
    goList() {
      this.$emit('updateCajasRegistros');
    },
    goBack() {
      this.$emit('closeApertura');
    },
    cajaActualizada(cajaNombre) {
      this.cajaNombre = cajaNombre;
    },    
  },
}
</script>

<style>
</style>
